package com.evoapps.evoshift.ui.roster

import com.evoapps.evoshift.ui.util.monthInSentence
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.util.usesDecimalComma
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.NotificationsActive
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.capacity.AvailabilityAnswer
import evoshift.composeapp.generated.resources.capacity_answer_sent_by_email
import com.evoapps.evoshift.domain.capacity.CapacityExclusion
import com.evoapps.evoshift.domain.capacity.CapacitySummary
import com.evoapps.evoshift.domain.capacity.PersonCapacity
import com.evoapps.evoshift.domain.capacity.monthRange
import com.evoapps.evoshift.domain.schedule.ScheduleRange
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.CentredLazyColumn
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.finance.formatDecimal
import com.evoapps.evoshift.ui.user.contractLabel
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayAndMonth
import com.evoapps.evoshift.util.appLanguage
import com.evoapps.evoshift.viewmodels.RosterCapacityEvent
import com.evoapps.evoshift.viewmodels.RosterCapacityUiState
import com.evoapps.evoshift.viewmodels.RosterCapacityViewModel
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.back
import evoshift.composeapp.generated.resources.capacity_answer_no_app
import evoshift.composeapp.generated.resources.capacity_answer_none
import evoshift.composeapp.generated.resources.capacity_answer_reminded
import evoshift.composeapp.generated.resources.capacity_answer_sent
import evoshift.composeapp.generated.resources.capacity_answer_started
import evoshift.composeapp.generated.resources.capacity_apply
import evoshift.composeapp.generated.resources.capacity_available
import evoshift.composeapp.generated.resources.capacity_available_detail
import evoshift.composeapp.generated.resources.capacity_available_detail_no_contracts
import evoshift.composeapp.generated.resources.capacity_choose_days
import evoshift.composeapp.generated.resources.capacity_choose_days_text
import evoshift.composeapp.generated.resources.capacity_col_answer
import evoshift.composeapp.generated.resources.capacity_col_available
import evoshift.composeapp.generated.resources.capacity_col_person
import evoshift.composeapp.generated.resources.capacity_col_planned
import evoshift.composeapp.generated.resources.capacity_col_target
import evoshift.composeapp.generated.resources.capacity_days
import evoshift.composeapp.generated.resources.capacity_demand
import evoshift.composeapp.generated.resources.capacity_demand_detail
import evoshift.composeapp.generated.resources.capacity_everyone_answered
import evoshift.composeapp.generated.resources.capacity_excluded
import evoshift.composeapp.generated.resources.capacity_excluded_detail
import evoshift.composeapp.generated.resources.capacity_excluded_employment
import evoshift.composeapp.generated.resources.capacity_excluded_owner
import evoshift.composeapp.generated.resources.capacity_gap
import evoshift.composeapp.generated.resources.capacity_gap_even
import evoshift.composeapp.generated.resources.capacity_gap_short
import evoshift.composeapp.generated.resources.capacity_gap_spare
import evoshift.composeapp.generated.resources.capacity_hours
import evoshift.composeapp.generated.resources.capacity_how
import evoshift.composeapp.generated.resources.capacity_missing_title
import evoshift.composeapp.generated.resources.capacity_no_request
import evoshift.composeapp.generated.resources.capacity_norm
import evoshift.composeapp.generated.resources.capacity_norm_detail
import evoshift.composeapp.generated.resources.capacity_people
import evoshift.composeapp.generated.resources.capacity_person_absent
import evoshift.composeapp.generated.resources.capacity_person_available
import evoshift.composeapp.generated.resources.capacity_person_no_target
import evoshift.composeapp.generated.resources.capacity_person_planned
import evoshift.composeapp.generated.resources.capacity_person_target
import evoshift.composeapp.generated.resources.capacity_person_target_month
import evoshift.composeapp.generated.resources.capacity_remind
import evoshift.composeapp.generated.resources.capacity_reminder_message
import evoshift.composeapp.generated.resources.capacity_reminder_message_due
import evoshift.composeapp.generated.resources.capacity_reminder_title
import evoshift.composeapp.generated.resources.capacity_request_days
import evoshift.composeapp.generated.resources.capacity_targets
import evoshift.composeapp.generated.resources.capacity_targets_detail
import evoshift.composeapp.generated.resources.capacity_title
import evoshift.composeapp.generated.resources.capacity_whole_month
import kotlin.math.abs
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.stringResource

private val ShortColor = Color(0xFFC62828)
private val SpareColor = Color(0xFF2E7D32)

/** "94 h", "93.5 h" ("93,5 h" in Polish): at most one decimal. */
@Composable
internal fun hoursText(hours: Double): String {
    val polish = usesDecimalComma(appLanguage())
    val text = formatDecimal(hours, 1, groupSeparator = if (polish) ' ' else ',', decimalSeparator = if (polish) ',' else '.')
    return stringResource(Res.string.capacity_hours, text.removeSuffix(if (polish) ",0" else ".0"))
}

/**
 * Capacity before planning a month (SH-48), from the month's card in Rosters: how many hours the
 * skeleton needs, how many the team offered (without the owner and employment contracts, like the
 * owner's sheet), contract targets and the full-time norm, for the whole month or some of its days,
 * and who has not sent their availability, with a reminder. Read-only except the reminder.
 */
@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun RosterCapacityScreen(viewModel: RosterCapacityViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val message = state.message?.asString()
    LaunchedEffect(message) {
        message?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(RosterCapacityEvent.MessageShown)
        }
    }
    var choosingDays by remember { mutableStateOf(false) }
    val range = state.range
    if (choosingDays && range != null) {
        DayRangeDialog(
            title = stringResource(Res.string.capacity_choose_days),
            year = state.year,
            month = state.month,
            initial = range,
            text = stringResource(Res.string.capacity_choose_days_text),
            confirmLabel = stringResource(Res.string.capacity_apply),
            onConfirm = {
                viewModel.onEvent(RosterCapacityEvent.SetRange(it.start, it.endInclusive))
                choosingDays = false
            },
            onDismiss = { choosingDays = false }
        )
    }
    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                // The month is the bar's (SH-89); the day range stays with the title.
                title = stringResource(Res.string.capacity_title) +
                    (if (state.year > 0 && range != null) " · ${dayRangeLabel(range, state.year, state.month)}" else ""),
                onBack = onNavigateBack,
                showWorkplace = true,
                showMonth = true,
                actions = listOf(helpAction(HelpPage.CAPACITY))
            )
        }
    ) { padding ->
        val summary = state.summary
        when {
            summary == null && state.isLoading ->
                Box(Modifier.fillMaxSize().padding(padding), Alignment.Center) { CircularProgressIndicator(color = DeepNavy) }
            summary == null -> Box(Modifier.fillMaxSize().padding(padding), Alignment.Center) {
                Text(state.error?.asString().orEmpty(), color = MaterialTheme.colorScheme.error, modifier = Modifier.padding(24.dp))
            }
            else -> {
                val widthClass = LocalWindowWidthClass.current
                CentredLazyColumn(
                    maxWidth = WideContentMaxWidth,
                    modifier = Modifier.padding(padding),
                    contentPadding = PaddingValues(16.dp),
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    item { RangeChips(state, summary.range, onChoose = { choosingDays = true }, onEvent = viewModel::onEvent) }
                    item { RequestLine(summary) }
                    item { Totals(summary, wide = !widthClass.isCompact) }
                    item {
                        // The push text, in the sender's language (the app shows its own from the data).
                        val reminderTitle = stringResource(Res.string.capacity_reminder_title)
                        val monthLabel = monthInSentence(state.month)
                        val due = summary.request?.dueDate?.let { runCatching { LocalDate.parse(it.take(10)) }.getOrNull() }
                        val reminderMessage = if (due != null) {
                            stringResource(Res.string.capacity_reminder_message_due, monthLabel, state.year, dayAndMonth(due))
                        } else {
                            stringResource(Res.string.capacity_reminder_message, monthLabel, state.year)
                        }
                        Missing(state, summary) { viewModel.onEvent(RosterCapacityEvent.RemindMissing(reminderTitle, reminderMessage)) }
                    }
                    item {
                        Text(
                            stringResource(Res.string.capacity_people),
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.Bold,
                            color = DeepNavy,
                            modifier = Modifier.padding(top = 8.dp)
                        )
                    }
                    if (widthClass.isExpanded) {
                        item { PeopleTable(summary, state.reminded) }
                    } else {
                        items(summary.people, key = { it.userId }) { PersonCard(it, summary.payTermsVisible, it.userId in state.reminded) }
                    }
                    item {
                        Text(
                            stringResource(Res.string.capacity_how),
                            style = MaterialTheme.typography.bodySmall,
                            color = DeepNavy.copy(alpha = 0.6f)
                        )
                    }
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun RangeChips(state: RosterCapacityUiState, range: ScheduleRange, onChoose: () -> Unit, onEvent: (RosterCapacityEvent) -> Unit) {
    val month = monthRange(state.year, state.month)
    val firstHalf = ScheduleRange(month.start, LocalDate(state.year, state.month, 15))
    val secondHalf = ScheduleRange(LocalDate(state.year, state.month, 16), month.endInclusive)
    val colors = FilterChipDefaults.filterChipColors(
        selectedContainerColor = DeepNavy,
        selectedLabelColor = Color.White,
        selectedLeadingIconColor = Color.White,
        labelColor = DeepNavy,
        iconColor = DeepNavy
    )
    val custom = range != month && range != firstHalf && range != secondHalf
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        FilterChip(
            selected = range == month,
            onClick = { onEvent(RosterCapacityEvent.WholeMonth) },
            label = { Text(stringResource(Res.string.capacity_whole_month)) },
            colors = colors
        )
        listOf(firstHalf, secondHalf).forEach { half ->
            FilterChip(
                selected = range == half,
                onClick = { onEvent(RosterCapacityEvent.SetRange(half.start, half.endInclusive)) },
                label = { Text(stringResource(Res.string.capacity_days, half.start.day, half.endInclusive.day)) },
                colors = colors
            )
        }
        FilterChip(
            selected = custom,
            onClick = onChoose,
            leadingIcon = { Icon(Icons.Default.DateRange, null, modifier = Modifier.size(18.dp)) },
            label = {
                Text(if (custom) stringResource(Res.string.capacity_days, range.start.day, range.endInclusive.day) else stringResource(Res.string.capacity_choose_days))
            },
            colors = colors
        )
    }
}

@Composable
private fun RequestLine(summary: CapacitySummary) {
    val request = summary.request
    val start = request?.period?.startDate?.let { runCatching { LocalDate.parse(it.take(10)) }.getOrNull() }
    val end = request?.period?.endDate?.let { runCatching { LocalDate.parse(it.take(10)) }.getOrNull() }
    val due = request?.dueDate?.let { runCatching { LocalDate.parse(it.take(10)) }.getOrNull() }
    val text = if (start != null && end != null && due != null) {
        stringResource(Res.string.capacity_request_days, start.day, end.day, dayAndMonth(due))
    } else {
        stringResource(Res.string.capacity_no_request)
    }
    Text(text, style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.75f))
}

/** One figure: its label, value and what it means. */
private data class Metric(val label: String, val value: String, val detail: String?, val color: Color = DeepNavy)

@Composable
private fun Totals(summary: CapacitySummary, wide: Boolean) {
    val gap = summary.gap
    val gapText = when {
        abs(gap) < 0.05 -> stringResource(Res.string.capacity_gap_even)
        gap > 0 -> stringResource(Res.string.capacity_gap_short, hoursText(gap))
        else -> stringResource(Res.string.capacity_gap_spare, hoursText(-gap))
    }
    val metrics = buildList {
        add(Metric(
            stringResource(Res.string.capacity_demand), hoursText(summary.demandHours),
            stringResource(Res.string.capacity_demand_detail, summary.demandShifts, summary.openShifts, hoursText(summary.openHours))
        ))
        add(Metric(
            stringResource(Res.string.capacity_available), hoursText(summary.availableHours),
            stringResource(if (summary.payTermsVisible) Res.string.capacity_available_detail else Res.string.capacity_available_detail_no_contracts)
        ))
        add(Metric(stringResource(Res.string.capacity_gap), gapText, null, if (gap > 0.05) ShortColor else SpareColor))
        add(Metric(
            stringResource(Res.string.capacity_norm), hoursText(summary.nominalHours.toDouble()),
            stringResource(Res.string.capacity_norm_detail, hoursText(summary.nominalHours.toDouble()), hoursText(summary.monthNominalHours.toDouble()))
        ))
        summary.targetHours?.let {
            add(Metric(stringResource(Res.string.capacity_targets), hoursText(it), stringResource(Res.string.capacity_targets_detail)))
        }
        if (summary.people.any { !it.isCounted }) {
            add(Metric(
                stringResource(Res.string.capacity_excluded), hoursText(summary.excludedAvailableHours),
                stringResource(Res.string.capacity_excluded_detail, hoursText(summary.excludedAvailableHours))
            ))
        }
    }
    if (wide) {
        // Tablets and desktops: three figures a row.
        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
            metrics.chunked(3).forEach { row ->
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    row.forEach { MetricTile(it) }
                    repeat(3 - row.size) { Spacer(Modifier.weight(1f)) }
                }
            }
        }
    } else {
        RegularCard(Modifier.fillMaxWidth()) {
            Column(Modifier.padding(16.dp)) {
                metrics.forEachIndexed { i, metric ->
                    if (i > 0) HorizontalDivider(Modifier.padding(vertical = 10.dp), color = DeepNavy.copy(alpha = 0.1f))
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(metric.label, color = DeepNavy, fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f))
                        Text(metric.value, color = metric.color, fontWeight = FontWeight.Bold, textAlign = TextAlign.End, modifier = Modifier.padding(start = 12.dp))
                    }
                    metric.detail?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f)) }
                }
            }
        }
    }
}

@Composable
private fun RowScope.MetricTile(metric: Metric) {
    RegularCard(Modifier.weight(1f)) {
        Column(Modifier.padding(16.dp).height(96.dp)) {
            Text(metric.label, style = MaterialTheme.typography.labelLarge, color = DeepNavy.copy(alpha = 0.7f))
            Text(metric.value, style = MaterialTheme.typography.headlineSmall, color = metric.color, fontWeight = FontWeight.Bold)
            metric.detail?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f), maxLines = 2, overflow = TextOverflow.Ellipsis) }
        }
    }
}

@Composable
private fun answerText(person: PersonCapacity, reminded: Boolean): String = when {
    // SH-173: given through the e-mailed link's web form.
    person.answer == AvailabilityAnswer.SUBMITTED && person.answeredByEmail -> stringResource(Res.string.capacity_answer_sent_by_email)
    person.answer == AvailabilityAnswer.SUBMITTED -> stringResource(Res.string.capacity_answer_sent)
    reminded -> stringResource(Res.string.capacity_answer_reminded)
    person.isShadow -> stringResource(Res.string.capacity_answer_no_app)
    person.answer == AvailabilityAnswer.STARTED -> stringResource(Res.string.capacity_answer_started)
    else -> stringResource(Res.string.capacity_answer_none)
}

@Composable
private fun Missing(state: RosterCapacityUiState, summary: CapacitySummary, onRemind: () -> Unit) {
    val missing = summary.missing
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            if (missing.isEmpty()) {
                Text(stringResource(Res.string.capacity_everyone_answered), color = SpareColor, fontWeight = FontWeight.Bold)
                return@Column
            }
            Text(stringResource(Res.string.capacity_missing_title, missing.size), color = DeepNavy, fontWeight = FontWeight.Bold)
            missing.forEach { person ->
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(person.displayName, color = DeepNavy, modifier = Modifier.weight(1f), maxLines = 1, overflow = TextOverflow.Ellipsis)
                    Text(
                        answerText(person, person.userId in state.reminded),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.7f),
                        modifier = Modifier.padding(start = 12.dp)
                    )
                }
            }
            if (state.canRemind) {
                Spacer(Modifier.height(4.dp))
                Button(
                    onClick = onRemind,
                    enabled = !state.isReminding,
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Icon(Icons.Default.NotificationsActive, null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.capacity_remind, state.remindable.size), fontWeight = FontWeight.Bold)
                }
            }
        }
    }
}

@Composable
private fun targetText(person: PersonCapacity, payTermsVisible: Boolean): String? {
    if (!payTermsVisible) return null
    val target = person.target?.hours ?: return stringResource(Res.string.capacity_person_no_target)
    val monthly = person.monthlyTarget?.hours
    return if (monthly != null && abs(monthly - target) > 0.05) {
        stringResource(Res.string.capacity_person_target_month, hoursText(target), hoursText(monthly))
    } else {
        stringResource(Res.string.capacity_person_target, hoursText(target))
    }
}

@Composable
private fun exclusionText(person: PersonCapacity): String? = when (person.excludedAs) {
    CapacityExclusion.OWNER -> stringResource(Res.string.capacity_excluded_owner)
    CapacityExclusion.EMPLOYMENT_CONTRACT -> stringResource(Res.string.capacity_excluded_employment)
    null -> null
}

@Composable
private fun PersonCard(person: PersonCapacity, payTermsVisible: Boolean, reminded: Boolean) {
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(person.displayName, fontWeight = FontWeight.Bold, color = DeepNavy, modifier = Modifier.weight(1f), maxLines = 1, overflow = TextOverflow.Ellipsis)
                Text(answerText(person, reminded), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f), modifier = Modifier.padding(start = 12.dp))
            }
            val details = listOfNotNull(
                person.contract?.let { contractLabel(it) },
                person.role
            ).joinToString(" · ")
            if (details.isNotEmpty()) Text(details, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            Text(stringResource(Res.string.capacity_person_available, hoursText(person.availableHours), person.availableDays), color = DeepNavy)
            if (person.absentDays > 0) {
                Text(stringResource(Res.string.capacity_person_absent, person.absentDays), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            }
            targetText(person, payTermsVisible)?.let { Text(it, color = DeepNavy) }
            Text(stringResource(Res.string.capacity_person_planned, hoursText(person.plannedHours)), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            exclusionText(person)?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.6f)) }
        }
    }
}

@Composable
private fun PeopleTable(summary: CapacitySummary, reminded: Set<String>) {
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp)) {
            Row {
                HeaderCell(stringResource(Res.string.capacity_col_person), 2.2f, TextAlign.Start)
                HeaderCell(stringResource(Res.string.capacity_col_answer), 1.6f, TextAlign.Start)
                HeaderCell(stringResource(Res.string.capacity_col_available), 1.2f)
                if (summary.payTermsVisible) HeaderCell(stringResource(Res.string.capacity_col_target), 1.2f)
                HeaderCell(stringResource(Res.string.capacity_col_planned), 1.2f)
            }
            summary.people.forEach { person ->
                HorizontalDivider(Modifier.padding(vertical = 8.dp), color = DeepNavy.copy(alpha = 0.1f))
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(2.2f)) {
                        Text(person.displayName, color = DeepNavy, fontWeight = FontWeight.Bold, maxLines = 1, overflow = TextOverflow.Ellipsis)
                        val sub = listOfNotNull(person.contract?.let { contractLabel(it) }, exclusionText(person)).joinToString(" · ")
                        if (sub.isNotEmpty()) Text(sub, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.6f))
                    }
                    ValueCell(answerText(person, person.userId in reminded), 1.6f, TextAlign.Start)
                    ValueCell(hoursText(person.availableHours), 1.2f)
                    if (summary.payTermsVisible) ValueCell(person.target?.hours?.let { hoursText(it) } ?: "–", 1.2f)
                    ValueCell(hoursText(person.plannedHours), 1.2f)
                }
            }
        }
    }
}

@Composable
private fun RowScope.HeaderCell(text: String, weight: Float, align: TextAlign = TextAlign.End) {
    Text(text, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.6f), textAlign = align, modifier = Modifier.weight(weight))
}

@Composable
private fun RowScope.ValueCell(text: String, weight: Float, align: TextAlign = TextAlign.End) {
    Text(text, color = DeepNavy, textAlign = align, modifier = Modifier.weight(weight), maxLines = 1, overflow = TextOverflow.Ellipsis)
}
